import React from 'react'
import { useAuthenticatedUserId } from '../../../../hooks/useAuthenticatedUserId'
import { useAppTranslation } from '../../../../hooks/useAppTranslation'
import { ITimeSlot } from '../FacilityCalendar/interfaces'
import { TimeSlotTime } from '../TimeSlotTime'

interface TimeSlotProps extends ITimeSlot {
  onClick: () => void
  selected: boolean
  fullDay?: boolean
  userHasReachedMaxNumberOfBookings: boolean
}

export const TimeSlot = ({
  startDate,
  endDate,
  bookingUserId,
  onClick,
  selected,
  fullDay,
  userHasReachedMaxNumberOfBookings,
}: TimeSlotProps): JSX.Element | null => {
  const userId = useAuthenticatedUserId() as string
  const { translate } = useAppTranslation()

  const authenticatedUserOwnsBooking = bookingUserId && bookingUserId === userId

  const otherUserOwnsBooking = bookingUserId && !authenticatedUserOwnsBooking

  return (
    <button
      className={`border-1 rounded-md border border-neutral-80 px-5 py-4 shadow-sm 
      ${selected ? 'bg-neutral-30 text-white' : ''}
      ${
        userHasReachedMaxNumberOfBookings && !authenticatedUserOwnsBooking
          ? 'text-neutral-80'
          : ''
      }
      ${bookingUserId !== undefined || selected ? '' : 'hover:bg-gray-light'}
       ${authenticatedUserOwnsBooking ? 'bg-greenDark text-white' : ''}
      `}
      disabled={
        bookingUserId !== undefined ||
        (userHasReachedMaxNumberOfBookings && !authenticatedUserOwnsBooking)
      }
      onClick={onClick}
    >
      {authenticatedUserOwnsBooking && (
        <p className="text-center font-semibold">
          {translate('facilityView.calendar.booked')}
        </p>
      )}
      <TimeSlotTime
        startDate={startDate}
        endDate={endDate}
        fullDay={fullDay}
        small={Boolean(authenticatedUserOwnsBooking)}
        className={otherUserOwnsBooking ? 'opacity-40' : ''}
      />
    </button>
  )
}
